import React from 'react'
import c from './img/asterisk.png'
///import cc from './img/down.png'
import { Container   } from 'react-bootstrap';
import LightSpeed from 'react-reveal/LightSpeed';

export const Permitforuseexceeds = () => (

<Container>


 <div style={styles.container}>
      <LightSpeed right>
        <div style={styles.card}>
          
          {/* כותרת הסבר */}
          <p style={styles.introText}>
            על פי הנחיות היועץ המשפטי לממשלה בנוגע לרישוי עסקים במבנים שאינם מוסדרים, 
            המחלקה לתכנון ולרישוי הנדסי בודקת את התאמת הבקשה לדיני התכנון והבנייה בנושאים הבאים:
          </p>

          {/* רשימת בדיקות מעוצבת */}
          <div style={styles.listContainer}>
            <div style={styles.listItem}>
              <img src={c} alt="check" style={styles.listIcon} />
              <p style={styles.listText}>חוקיות המבנה והיתר הבנייה.</p>
            </div>

            <div style={styles.listItem}>
              <img src={c} alt="check" style={styles.listIcon} />
              <p style={styles.listText}>
                במידה ואין היתר בנייה - נבדקת מידת העמידה בהגדרות המאפשרות קבלת רישיון עסק ללא היתר.
              </p>
            </div>

            <div style={styles.listItem}>
              <img src={c} alt="check" style={styles.listIcon} />
              <p style={styles.listText}>
                התאמת השימוש בנכס לייעוד המבנה על פי היתר הבנייה ותוכנית בניין עיר (תב"ע).
              </p>
            </div>
          </div>

          <p style={styles.secondaryText}>
            בדיקה זו מתבצעת במידה והשימוש המבוקש אינו תואם את היתר הבנייה או התב"ע הקיימת.
          </p>

          {/* תיבת התראה לתיקון 101 */}
          <div style={styles.warningBox}>
            <span style={styles.warningTitle}>חשוב לדעת:</span>
            <p style={styles.warningText}>
              על פי <strong>תיקון 101</strong>, בעל העסק נדרש להגיש בקשה לקבלת היתר לשימוש חורג 
              באמצעות המערכת הארצית של "רישוי זמין".
            </p>
          </div>

        </div>
      </LightSpeed>
    </div>


  
  </Container>




)


const styles = {
  container: {
    direction: 'rtl',
    padding: '30px 15px',
    display: 'flex',
    justifyContent: 'center',
  },
  card: {
    maxWidth: '850px',
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    padding: '40px',
    boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
    border: '1px solid #e2e8f0',
  },
  introText: {
    fontSize: '1.15rem',
    color: '#2d3748',
    lineHeight: '1.6',
    marginBottom: '30px',
    fontWeight: '500',
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    marginBottom: '30px',
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px',
    backgroundColor: '#f7fafc',
    padding: '15px 20px',
    borderRadius: '12px',
  },
  listIcon: {
    width: '24px',
    height: '24px',
    marginTop: '3px',
  },
  listText: {
    margin: 0,
    fontSize: '1.05rem',
    color: '#4a5568',
    lineHeight: '1.5',
  },
  secondaryText: {
    fontSize: '0.95rem',
    color: '#718096',
    fontStyle: 'italic',
    marginBottom: '35px',
  },
  warningBox: {
    backgroundColor: '#fff5f5',
    borderRight: '5px solid #e53e3e',
    padding: '20px',
    borderRadius: '8px',
  },
  warningTitle: {
    display: 'block',
    color: '#c53030',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    marginBottom: '5px',
  },
  warningText: {
    margin: 0,
    color: '#2d3748',
    fontSize: '1.05rem',
    lineHeight: '1.6',
  }
};